import { useState, useEffect } from "react";
import "@/App.css";

// Assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/8qlrdtky_rex%20group.png";
const RW_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/zmymexkb_download%20%282%29.jpeg";
const NSW_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/b26ugfii_NSW.png";
const RWC_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/lmd03klv_images%20%281%29.png";
const HEALTHSHARE_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/eu3r5o1p_healthsharensw.png";
const CPG_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/9dh7m5l7_image-50-300x264.png";
const MONTESSORI_LOGO = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/3vr0xmyk_montessori.webp";
const INSURED_BADGE = "https://customer-assets.emergentagent.com/job_rex-group-hub/artifacts/e2cjym9o_insured.jpeg";

// Icons
const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"/></svg>
);

const Phone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
);

const Mail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
);

const MapPin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
);

const Check = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
);

const Building = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>
);

const Wrench = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
);

const Shield = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>
);

const Camera = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>
);

const Trees = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z"/><path d="M7 16v6"/><path d="M13 19v3"/><path d="M18 22V13.2A3 3 0 0 0 19.1 8h0a3 3 0 0 0-6.2 0v0A3 3 0 0 0 14 13v0h5"/></svg>
);

const Hammer = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 12-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 0 1 0-3L12 9"/><path d="M17.64 15 22 10.64"/><path d="m20.91 11.7-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47l2.26 1.91"/></svg>
);

const Sparkles = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/></svg>
);

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
);

const Menu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
);

const X = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
);

// Consultation Popup Component
const ConsultationPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      onClose();
      setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    }, 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose} data-testid="consultation-popup-overlay">
      <div className="popup" onClick={(e) => e.stopPropagation()} data-testid="consultation-popup">
        <button className="popup__close" onClick={onClose} data-testid="popup-close">
          <X />
        </button>
        <div className="popup__badge">FREE</div>
        <h2 className="popup__title">Book Your Free Consultation</h2>
        <p className="popup__description">
          Let us assess your facility needs and show you how REX Group Solutions can take complete control of your site management.
        </p>
        
        {submitted ? (
          <div className="popup__success" data-testid="popup-success">
            <Check />
            <span>Thank you! We'll contact you within 24 hours.</span>
          </div>
        ) : (
          <form className="popup__form" onSubmit={handleSubmit} data-testid="popup-form">
            <div className="popup__form-row">
              <input
                type="text"
                placeholder="Your Name *"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                data-testid="popup-input-name"
              />
              <input
                type="email"
                placeholder="Email Address *"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                data-testid="popup-input-email"
              />
            </div>
            <div className="popup__form-row">
              <input
                type="tel"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                data-testid="popup-input-phone"
              />
              <input
                type="text"
                placeholder="Company Name"
                value={formData.company}
                onChange={(e) => setFormData({...formData, company: e.target.value})}
                data-testid="popup-input-company"
              />
            </div>
            <textarea
              placeholder="Tell us about your facility..."
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
              rows="3"
              data-testid="popup-input-message"
            ></textarea>
            <button type="submit" className="btn btn--primary btn--full" data-testid="popup-submit">
              Request Free Consultation
              <ArrowRight />
            </button>
          </form>
        )}
        
        <p className="popup__note">No obligation. No pressure. Just solutions.</p>
      </div>
    </div>
  );
};

// Navigation Component
const Navigation = ({ onOpenConsultation }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''}`} data-testid="main-navigation">
      <div className="nav__container">
        <a href="#" className="nav__logo" data-testid="nav-logo">
          <img src={LOGO_URL} alt="REX Group Solutions" />
        </a>
        
        <div className={`nav__links ${mobileMenuOpen ? 'nav__links--open' : ''}`}>
          <button onClick={() => scrollToSection('home')} className="nav__link" data-testid="nav-home">Home</button>
          <button onClick={() => scrollToSection('services')} className="nav__link" data-testid="nav-services">Services</button>
          <button onClick={() => scrollToSection('about')} className="nav__link" data-testid="nav-about">About</button>
          <button onClick={() => { onOpenConsultation(); setMobileMenuOpen(false); }} className="nav__link nav__link--cta" data-testid="nav-contact">
            <span className="nav__free-badge">FREE</span>
            Consultation
          </button>
        </div>
        
        <button className="nav__mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-toggle">
          {mobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </nav>
  );
};

// Hero Section
const Hero = ({ onOpenConsultation }) => {
  return (
    <section id="home" className="hero" data-testid="hero-section">
      <div className="hero__overlay"></div>
      <div className="hero__content">
        <span className="hero__tagline">Integrated Facility Management</span>
        <h1 className="hero__title">
          One Partner.<br/>
          <span className="hero__title--accent">Complete Control.</span>
        </h1>
        <p className="hero__description">
          REX Group Solutions delivers complete facility management solutions, taking full responsibility for the day-to-day operation, maintenance, and compliance of your site.
        </p>
        <div className="hero__cta">
          <button onClick={onOpenConsultation} className="btn btn--primary btn--glow" data-testid="hero-cta-button">
            Get Your Free Consultation
            <ArrowRight />
          </button>
          <a href="tel:0294241284" className="btn btn--secondary" data-testid="hero-phone-button">
            <Phone />
            02 9424 1284
          </a>
        </div>
      </div>
      <div className="hero__scroll-indicator">
        <ChevronDown />
      </div>
    </section>
  );
};

// Partners Section
const Partners = () => {
  return (
    <section className="partners" data-testid="partners-section">
      <div className="partners__container">
        <span className="partners__label">Trusted By Industry Leaders</span>
        <div className="partners__logos">
          <img src={RW_LOGO} alt="R&W" className="partners__logo" data-testid="partner-rw" />
          <img src={NSW_LOGO} alt="NSW Government" className="partners__logo" data-testid="partner-nsw" />
          <img src={RWC_LOGO} alt="RWC" className="partners__logo" data-testid="partner-rwc" />
          <img src={HEALTHSHARE_LOGO} alt="HealthShare NSW" className="partners__logo partners__logo--tall" data-testid="partner-healthshare" />
          <img src={CPG_LOGO} alt="CPG" className="partners__logo" data-testid="partner-cpg" />
          <img src={MONTESSORI_LOGO} alt="Montessori Academy" className="partners__logo partners__logo--tall" data-testid="partner-montessori" />
        </div>
      </div>
    </section>
  );
};

// Services Data
const services = [
  {
    icon: <Sparkles />,
    title: "Cleaning & Hygiene",
    items: [
      "General and routine cleaning",
      "Deep cleaning and periodic services",
      "Carpet and upholstery cleaning",
      "Internal and external window cleaning",
      "Washroom hygiene services",
      "Pressure washing"
    ]
  },
  {
    icon: <Wrench />,
    title: "Building Maintenance",
    subtitle: "Mechanical, Electrical & Plumbing",
    items: [
      "HVAC servicing and air conditioning maintenance",
      "Electrical systems and lighting maintenance",
      "Plumbing maintenance and repairs",
      "Preventative and reactive maintenance programs"
    ]
  },
  {
    icon: <Trees />,
    title: "Grounds & External Maintenance",
    items: [
      "Lawn and garden maintenance",
      "Landscaping and irrigation",
      "Car park cleaning and maintenance",
      "External building cleaning and washdowns"
    ]
  },
  {
    icon: <Hammer />,
    title: "General Maintenance & Minor Works",
    items: [
      "Handyman services and reactive repairs",
      "Painting, patching, and touch-ups",
      "Make-good works and reinstatements",
      "Minor fit-outs and project works"
    ]
  },
  {
    icon: <Shield />,
    title: "Compliance & Fire Safety",
    items: [
      "Fire equipment servicing and testing",
      "Emergency lighting and exit systems",
      "Fire panel and safety system checks",
      "Compliance reporting and logbooks",
      "Scheduled statutory maintenance"
    ]
  },
  {
    icon: <Camera />,
    title: "Security & Access Control",
    items: [
      "CCTV systems and monitoring",
      "Access control systems",
      "Alarm and intercom systems",
      "Site security coordination"
    ]
  }
];

// Services Section
const Services = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  return (
    <section id="services" className="services" data-testid="services-section">
      <div className="services__container">
        <div className="services__header">
          <span className="services__label">What We Deliver</span>
          <h2 className="services__title">Integrated Facility Management Services</h2>
          <p className="services__intro">
            REX Group Solutions delivers complete facility management solutions, taking full responsibility for the day-to-day operation, maintenance, and compliance of your site. We eliminate the need for multiple contractors by providing a single, accountable partner across all services.
          </p>
        </div>
        
        <div className="services__grid">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`service-card ${expandedCard === index ? 'service-card--expanded' : ''}`}
              onClick={() => setExpandedCard(expandedCard === index ? null : index)}
              data-testid={`service-card-${index}`}
            >
              <div className="service-card__icon">{service.icon}</div>
              <h3 className="service-card__title">{service.title}</h3>
              {service.subtitle && <span className="service-card__subtitle">{service.subtitle}</span>}
              <ul className="service-card__list">
                {service.items.map((item, i) => (
                  <li key={i}>
                    <Check />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Facility Management Layer Section
const FacilityManagement = () => {
  const managementServices = [
    "Vendor and contractor management",
    "Preventative maintenance scheduling",
    "Site inspections and reporting",
    "KPI and SLA management",
    "Rapid response to issues",
    "Ongoing optimisation of site performance"
  ];

  return (
    <section className="fm-layer" data-testid="fm-layer-section">
      <div className="fm-layer__container">
        <div className="fm-layer__content">
          <span className="fm-layer__label">Beyond Services</span>
          <h2 className="fm-layer__title">More Than Services — Complete Facility Management</h2>
          <p className="fm-layer__description">
            We don't just deliver services — we manage your entire facility. Our team acts as a single point of contact, overseeing all service delivery, coordinating maintenance, ensuring compliance, and maintaining consistent standards across your site.
          </p>
          <div className="fm-layer__grid">
            {managementServices.map((service, index) => (
              <div key={index} className="fm-layer__item">
                <Check />
                <span>{service}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="fm-layer__visual">
          <Building />
          <div className="fm-layer__visual-ring"></div>
          <div className="fm-layer__visual-ring fm-layer__visual-ring--2"></div>
        </div>
      </div>
    </section>
  );
};

// What We Take Off Your Plate Section
const ValueProposition = () => {
  const painPoints = [
    "Managing multiple contractors",
    "Chasing maintenance issues",
    "Dealing with inconsistent service quality",
    "Compliance tracking and reporting",
    "Delays and communication breakdowns"
  ];

  return (
    <section className="value-prop" data-testid="value-prop-section">
      <div className="value-prop__container">
        <div className="value-prop__header">
          <span className="value-prop__label">Your Challenges, Solved</span>
          <h2 className="value-prop__title">What We Take Off Your Plate</h2>
        </div>
        <div className="value-prop__list">
          {painPoints.map((point, index) => (
            <div key={index} className="value-prop__item">
              <div className="value-prop__x">
                <X />
              </div>
              <span>{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section
const About = () => {
  return (
    <section id="about" className="about" data-testid="about-section">
      <div className="about__container about__container--full">
        <div className="about__content about__content--centered">
          <span className="about__label">About Us</span>
          <h2 className="about__title">REX GROUP SOLUTIONS</h2>
          <p className="about__subtitle">Complete Facility Maintenance, All Managed In-House</p>
          <p className="about__description">
            We work closely with our clients to understand their challenges, timelines, and expectations, allowing us to deliver solutions that are practical and reliable. Through consistent follow-ups, clear communication, and professional service, we ensure every engagement supports productivity, growth, and workplace safety.
          </p>
          <div className="about__stats">
            <div className="about__stat">
              <span className="about__stat-number">100%</span>
              <span className="about__stat-label">Compliance Focus</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-number">24/7</span>
              <span className="about__stat-label">Support Available</span>
            </div>
            <div className="about__stat">
              <span className="about__stat-number">1</span>
              <span className="about__stat-label">Point of Contact</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({ name: '', email: '', phone: '', company: '', message: '' });
  };

  return (
    <section id="contact" className="contact" data-testid="contact-section">
      <div className="contact__container">
        <div className="contact__info">
          <span className="contact__label">Get In Touch</span>
          <h2 className="contact__title">Schedule a Free Consultation</h2>
          <p className="contact__description">
            Ready to take control of your facility management? Contact us today to discuss how REX Group Solutions can become your single, accountable partner.
          </p>
          
          <div className="contact__details">
            <a href="tel:0294241284" className="contact__detail" data-testid="contact-phone">
              <Phone />
              <span>02 9424 1284</span>
            </a>
            <a href="mailto:info@rexgroupsolutions.com.au" className="contact__detail" data-testid="contact-email">
              <Mail />
              <span>info@rexgroupsolutions.com.au</span>
            </a>
            <div className="contact__detail" data-testid="contact-address">
              <MapPin />
              <span>Sydney, NSW, Australia</span>
            </div>
          </div>
        </div>
        
        <form className="contact__form" onSubmit={handleSubmit} data-testid="contact-form">
          {submitted && (
            <div className="contact__success" data-testid="form-success">
              Thank you! We'll be in touch shortly.
            </div>
          )}
          <div className="contact__form-row">
            <input
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              data-testid="input-name"
            />
            <input
              type="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
              data-testid="input-email"
            />
          </div>
          <div className="contact__form-row">
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              data-testid="input-phone"
            />
            <input
              type="text"
              placeholder="Company Name"
              value={formData.company}
              onChange={(e) => setFormData({...formData, company: e.target.value})}
              data-testid="input-company"
            />
          </div>
          <textarea
            placeholder="Tell us about your facility management needs..."
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
            rows="4"
            data-testid="input-message"
          ></textarea>
          <button type="submit" className="btn btn--primary btn--full" data-testid="submit-button">
            Submit Enquiry
            <ArrowRight />
          </button>
        </form>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <img src={LOGO_URL} alt="REX Group Solutions" className="footer__logo" />
            <p className="footer__tagline">
              Your single, accountable partner for complete facility management.
            </p>
          </div>
          
          <div className="footer__links">
            <div className="footer__column">
              <h4>Services</h4>
              <ul>
                <li>Cleaning & Hygiene</li>
                <li>Building Maintenance</li>
                <li>Grounds Maintenance</li>
                <li>General Maintenance</li>
                <li>Compliance & Fire Safety</li>
                <li>Security & Access Control</li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4>Contact</h4>
              <ul>
                <li><a href="tel:0294241284">02 9424 1284</a></li>
                <li><a href="mailto:info@rexgroupsolutions.com.au">info@rexgroupsolutions.com.au</a></li>
                <li>Sydney, NSW, Australia</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer__bottom">
          <div className="footer__insured">
            <img src={INSURED_BADGE} alt="Fully Insured" data-testid="insured-badge" />
          </div>
          <div className="footer__legal">
            <p>ABN: 95 693 844 227</p>
            <p>ACN: 693 844 227</p>
          </div>
          <p className="footer__copyright">
            © {currentYear} REX Group Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

// Main App
function App() {
  const [showConsultation, setShowConsultation] = useState(false);

  return (
    <div className="app" data-testid="app">
      <Navigation onOpenConsultation={() => setShowConsultation(true)} />
      <Hero onOpenConsultation={() => setShowConsultation(true)} />
      <Partners />
      <Services />
      <FacilityManagement />
      <ValueProposition />
      <About />
      <Contact />
      <Footer />
      <ConsultationPopup isOpen={showConsultation} onClose={() => setShowConsultation(false)} />
      
      {/* Floating CTA Button */}
      <button 
        className="floating-cta" 
        onClick={() => setShowConsultation(true)}
        data-testid="floating-cta"
      >
        <span className="floating-cta__badge">FREE</span>
        <span>Get Consultation</span>
      </button>
    </div>
  );
}

export default App;
